import { useTheme, withThemeProvider } from "@narvar/nth-hook-theme";
import React, { FC } from "react";
import { useStyles } from "./StepListStyles";
import { StepProps } from "./types";
import { TextLink, StyledMarkup } from "..";
import GooglePlay from "../Icon/GooglePlay";
import AppStore from "../Icon/AppStore";

const Step: FC<StepProps> = ({ title, details, children, links = [] }) => {
  const {
    bodytextDefaultNone,
    iconsPrimaryNone,
    linksNoneDefault,
    linksNoneHover,
  } = useTheme();

  const styles = useStyles();

  return (
    <li
      className={styles.orderedListItem}
      style={{
        fontFamily: bodytextDefaultNone?.fontFamily,
        color: iconsPrimaryNone?.color,
        borderColor: iconsPrimaryNone?.color,
      }}>
      <div
        style={{
          ...bodytextDefaultNone,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}>
        <strong>
          <StyledMarkup content={title} />
        </strong>
        {details && <span className={styles.stepSpan}>{details}</span>}
        {links.length > 0 && (
          <div className={styles.linkContainer}>
            {links.map((link, i) => {
              let content = link.text;
              if (link.image) {
                const alt =
                  typeof link.text === "string" ? link.text : undefined;
                if (link.image === "app_store")
                  content = <AppStore alt={alt} />;
                else if (link.image === "google_play") {
                  content = <GooglePlay alt={alt} />;
                } else {
                  content = <img src={link.image} alt={alt} />;
                }
              }
              return (
                <TextLink
                  key={i}
                  href={link.url}
                  linkStyle={{
                    sDefault: linksNoneDefault,
                    sHover: linksNoneHover,
                  }}>
                  {content}
                </TextLink>
              );
            })}
          </div>
        )}
        {children}
      </div>
    </li>
  );
};

export default withThemeProvider(Step, {
  themeTokens: [
    "bodytextDefaultNone",
    "iconsPrimaryNone",
    "linksNoneDefault",
    "linksNoneHover",
    "buttonsPrimaryDefault",
    "buttonsPrimaryHover",
  ],
});
